// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3045":"815dfe06d3c8366a","3966":"9f929a9a1184e3ac"}[chunkId] + ".js";
};